import { FC } from 'react';
import { RouterProvider } from 'react-router';
import { routes } from '@/routes';
import { Toaster } from 'sonner';

const App: FC = () => {
  return (
    <>
      <Toaster richColors visibleToasts={2} />
      <RouterProvider router={routes} />
    </>
  );
};

export default App;
